import { enumItems } from './enumItems';
import { SchemaWithClient } from '../types/SchemaWithClient';
import { Client } from '../services/Client';
import { NumberField } from '../components/Table/fields/NumberField';
import { TextField } from '../components/Table/fields/TextField';
import { SelectField } from '../components/Table/fields/SelectField';
import { DateField } from '../components/Table/fields/DateField';
import { ActivityReservationCost } from '../types/entities/ActivityReservationCost';
import { serviceProvider } from './serviceProvider';
import { statuses } from './statuses';

export const activityReservationCost: SchemaWithClient<ActivityReservationCost> = {
  name: 'Activity Reservation Cost',
  pluralName: 'Activity Reservation Cost',
  columns: {
    name: {
      name: 'Name',
      required: true,
      fieldRenderer: TextField,
      fieldType: 'text',
      listItem: {
        width: '25%',
        align: 'left',
      },
    },
    service_provider: {
      name: 'Service Provider',
      required: true,
      fieldRenderer: SelectField.tableAdapter(serviceProvider),
      switchboard: true,
      url: serviceProvider.client.getAllPath,
      tempSchema: serviceProvider,
      listItem: {
        width: '25%',
        align: 'left',
      },
    },
    gross_cost: {
      name: 'Gross Cost',
      fieldRenderer: NumberField,
      fieldType: 'number',
      listItem: {
        width: '15%',
        align: 'left',
      },
    },
    currency: {
      name: 'Currency',
      fieldRenderer: SelectField.tableAdapter(enumItems.currency),
      switchboard: true,
      url: enumItems.currency.client.getAllPath,
      tempSchema: enumItems.currency,
      listItem: {
        width: '15%',
        align: 'left',
      },
    },
    vat_percent: {
      name: 'VAT Percent',
      fieldRenderer: NumberField,
      fieldType: 'number',
      listItem: {
        width: '10%',
        align: 'left',
      },
    },
    ifa_percent: {
      name: 'IFA Percent',
      fieldRenderer: NumberField,
      fieldType: 'number',
      listItem: {
        width: '10%',
        align: 'left',
      },
    },
    due_date: {
      name: 'Due Date',
      fieldRenderer: DateField,
      fieldType: 'date',
    },
    status: {
      name: 'Status',
      fieldRenderer: SelectField.tableAdapter(
        statuses.activityReservationCostStatus
      ),
      switchboard: true,
      url: statuses.activityReservationCostStatus.client.getAllPath,
      tempSchema: statuses.activityReservationCostStatus,
    },
    paid_by: {
      name: 'Paid By',
      fieldRenderer: SelectField.tableAdapter(enumItems.paidBy),
      switchboard: true,
      url: enumItems.paidBy.client.getAllPath,
      tempSchema: enumItems.paidBy,
    },
    payment_method: {
      name: 'Payment Method',
      fieldRenderer: SelectField.tableAdapter(enumItems.paymentMethod),
      switchboard: true,
      url: enumItems.paymentMethod.client.getAllPath,
      tempSchema: enumItems.paymentMethod,
    },
    id: {
      name: 'ID',
      required: true,
      fieldRenderer: NumberField,
      fieldType: 'number',
      readOnly: true,
    },
  },
  client: new Client('/activity-reservation-costs'),
};
